import { useRouter as useTanstackRouter } from "@tanstack/react-router"

type RouterWithNavigateAndReplaceHistory = {
  navigateAndReplaceHistory: (href: string) => void;
};

export const useRouter = (): RouterWithNavigateAndReplaceHistory => {
  const router = useTanstackRouter();

  return {
    ...router,
    navigateAndReplaceHistory: (href: string) => {
      router.history.flush();
      router.navigate({
        to: href
      });
    }
  };
};
